import { Routes } from '@angular/router';

import { mobileDeviceManagementSegments } from '@advania-cosoftware/wolf-router';

export const mobileDeviceManagementRoutes: Routes = [
    {
        path: mobileDeviceManagementSegments.mobileDeviceManagement,
        loadComponent: () =>
            import('./features/home/mobile-device-management-home/mobile-device-management-home.page').then(
                (m) => m.MobileDeviceManagementHomePage,
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: mobileDeviceManagementSegments.mobileDevices,
            },
            {
                path: mobileDeviceManagementSegments.mobileDevices,
                loadComponent: () =>
                    import('./features/mobile-devices-page/mobile-devices.page').then((m) => m.MobileDevicesPage),
            },
        ],
    },
];
